import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  CtaButtonComponent,
  RichTextLinkComponent,
} from '@digital-platform/rs-cms/feature-ptypes';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';
import { Cart } from '../cart-service/cart.model';
import { emptySimpleCart } from '../cart-service/shop-cart.constants';

@Component({
  selector: 'digital-platform-abandoned-cart-modal-component',
  templateUrl: './abandoned-cart-modal.component.html',
  styleUrls: ['./abandoned-cart-modal.component.scss'],
  standalone: true,
  imports: [
    CtaButtonComponent,
    IconComponent,
    RichTextLinkComponent,
    CommonModule,
  ],
})
export class AbandonedCartModalComponent {
  activeModal = inject(NgbActiveModal);
  @Input() cart: Cart = emptySimpleCart;
  @Input() title = '';

  @Output() cartAction = new EventEmitter();

  clearCart(): void {
    this.cart.items = [];
    this.cartAction.emit();

    setTimeout(() => {
      this.dismiss();
    }, 5000);
  }

  checkout(): void {
    this.activeModal.close(true);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  createCMSObject = function (nameOfProperty: string, valueOfProperty: string) {
    return {
      tid: 0,
      name: '',
      [nameOfProperty]: valueOfProperty,
    };
  };
}
